import { render, staticRenderFns } from "./customRecorderSlider.vue?vue&type=template&id=8fb9fa90&scoped=true&"
import script from "./customRecorderSlider.vue?vue&type=script&lang=js&"
export * from "./customRecorderSlider.vue?vue&type=script&lang=js&"
import style0 from "./customRecorderSlider.vue?vue&type=style&index=0&id=8fb9fa90&scoped=true&lang=css&"
import style1 from "./customRecorderSlider.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb9fa90",
  null
  
)

export default component.exports